import type { ReactElement } from "react"
import Layout from "@/components/common/Layout"
import { BlogHeader } from "@/components/resources/components/BlogHeader"
import { Main } from "@/components/resources/components/MainSiteContainer"

export function SiteLayout(page: ReactElement) {
  return (
    <Layout>
      <BlogHeader />
      <Main>{page}</Main>
    </Layout>
  )
}
